import React, { useEffect, useContext, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { LayoutContext } from "App/common/hoc/Layout";
import { checkValidity, objectToArray } from "utils";
import { inviteUsersStart } from "store/actions";

const UsersFailedList = props => {
  const { lMethods } = useContext(LayoutContext);
  const [formValid, setFormValid] = useState({ isValid: true, msg: "" });
  const [invites, setInvites] = useState([]);
  useEffect(() => {
    lMethods.updatePopupParams({
      execute: () => formSubmitHandler()
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.inviteStatus, invites]);

  useEffect(() => {
    if (
      props.inviteStatus &&
      props.inviteStatus.invalid_email &&
      props.inviteStatus.invalid_email.length < 1 &&
      props.inviteStatus.invite_email.length > 0
    ) {
      lMethods.closePopup();
    } else if (
      props.inviteStatus &&
      props.inviteStatus.invalid_email &&
      props.inviteStatus.invalid_email.length > 0
    ) {
      setInvites(props.inviteStatus.invalid_email);
    }
  }, [props.inviteStatus, invites]);

  function inputChangeHandler(val, index) {
    let updateInvites = { ...invites };
    setFormValid({ isValid: true, msg: "" });
    updateInvites[index].email = val.trim();
    setInvites(updateInvites);
  }

  function formSubmitHandler() {
    let isFormValid = true;
    const updatedEmailsObj = { emails: [] };
    if (invites.length > 0) {
      invites.map(invite => {
        if (!checkValidity(invite.email)) {
          setFormValid({
            isValid: false,
            msg: "Enter a valid email address."
          });
          isFormValid = false;
        } else {
          updatedEmailsObj.emails.push(invite.email);
        }
      });
      let findDuplicates = updatedEmailsObj.emails.filter(
        (item, index) => updatedEmailsObj.emails.indexOf(item) != index
      );
      if (findDuplicates.length > 0) {
        setFormValid({
          isValid: false,
          msg: "Please enter unique email address."
        });
      }
      if (isFormValid) {
        props.inviteUsersStart(updatedEmailsObj, true);
      }
    } else {
      setFormValid({
        isValid: false,
        msg: "No emails present to send the invite."
      });
    }
  }

  function deleteEmail(index) {
    let updatedInvites = { ...invites.splice(index, 1) };
    setInvites(objectToArray(updatedInvites));
    if (objectToArray(updatedInvites).length === 0 || invites.length === 0) {
      lMethods.closePopup();
    }
  }

  return (
    <React.Fragment>
      {props.popupLoading && (
        <div className="">
          <div className="popup_loader_bg   "></div>
          <div className="mirror_loader flex_center">
            <img
              src={
                process.env.REACT_APP_STATIC_URL + "/images/mirror_loader.gif"
              }
              alt="Mirror_Loader"
            />
          </div>
        </div>
      )}
      <div className="popup_form">
        <div className="invali_eamil_form">
          <p>
            Invites could not be sent to the following email addresses. You can
            modify and try sending again.
          </p>
          {formValid && !formValid.isValid && (
            <span className="error-msg">{formValid.msg}</span>
          )}
          {formValid &&
            formValid.isValid &&
            props.addUserInviteResent &&
            !props.popupLoading &&
            props.inviteStatus.invalid_email.length > 0 && (
              <span className="error-msg">
                Invitation could not be sent as one or more email addresses are
                already associated with IDrive Mirror
              </span>
            )}
          <div className="invali_eamil_box">
            <div className="ieb_header"> Email Address</div>
            <div className="ieb_box_scroll">
              <div className="ieb_inner">
                {props.inviteStatus &&
                  props.inviteStatus.invalid_email &&
                  props.inviteStatus.invalid_email.map((invite, i) => (
                    <div key={i} className="formInput">
                      <input
                        type="text"
                        className="txt_box invalid_emails"
                        value={invite.email}
                        onChange={e => inputChangeHandler(e.target.value, i)}
                        onKeyDown={e =>
                          e.key === "Enter" && formSubmitHandler()
                        }
                      />
                      <span
                        className="closeIcon"
                        data-toggle="tooltip"
                        title=""
                        data-original-title="Delete"
                        onClick={() => deleteEmail(i)}
                      ></span>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
function mapStateToProps(state) {
  return {
    inviteStatus: state.users.addUsers.inviteStatus,
    addUserInviteResent: state.users.addUsers.addUserInviteResent,
    popupLoading: state.users.popupLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ inviteUsersStart }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersFailedList);
